import { IconV2 } from 'components/common/IconV2/IconV2';
import type { SmallIconV2Props } from 'components/common/IconV2/IconV2.types';

const BellSmallIcon = (props: SmallIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 16 16">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.153 14a1.333 1.333 0 0 1-2.306 0M12 5.333a4 4 0 1 0-8 0c0 4.667-2 6-2 6h12s-2-1.333-2-6"
    />
  </IconV2>
);

export default BellSmallIcon;
